<template>
  <div>
    <div
      class="is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center is-flex-direction-column-mobile is-flex-direction-row"
    >
      <strong class="mb-2 mr-4"
        >Campos marcados com * são considerados obrigatórios</strong
      >
      <div
        v-if="hasPermitionToActivate() && $route.params.id"
        class="mb-2 mr-4"
      >
        <strong>Status:</strong>
        <StatusTag :status="form.status" class="ml-2" />
      </div>
      <div
        v-if="hasPermitionToActivate() && $route.params.id"
        class="is-flex is-align-items-center mb-2"
      >
        <b-switch v-model="ativo" @input="switchActiveStatus" class="mr-2"
          >Ativo</b-switch
        >
        <ApproveOrRefuseGroupButtons
          v-if="hasPermitionToApprove()"
          @refuse="(payload) => recusar(payload)"
          @approve="aprovar"
        />
      </div>
    </div>

    <hr />

    <!-- Áreas Permitidas -->
    <b-field grouped>
      <b-field label="Áreas Permitidas*">
        <div class="buttons has-addons">
          <b-checkbox v-model="form.areaPrimaria" v-if="!isRoleAreaSecundaria()"
            >Área Primária</b-checkbox
          >
          <b-checkbox
            v-model="form.areaSecundaria"
            :disabled="form.areaPrimaria"
            >Área Secundária</b-checkbox
          >
        </div>
      </b-field>
      <b-field label="Tipo*" expanded>
        <b-select v-model="form.tipo" expanded :disabled="$route.params.id">
          <option value="AVULSO">Avulso</option>
          <option value="PADRAO">Padrão</option>
        </b-select>
      </b-field>

      <b-field label="Classificação*" expanded>
        <b-select
          v-model="form.classificacao"
          expanded
          :disabled="$route.params.id && !isAdmin()"
        >
          <option value="AUTOMOVEL">Automóvel</option>
          <option value="MOTOCICLETA">Motocicleta</option>
          <option value="CAMINHAO">Caminhão</option>
          <option value="MAQUINA_MOVEL">Máquina Móvel</option>
        </b-select>
      </b-field>
    </b-field>

    <!-- Empresa e Tipo de Veiculo -->
    <b-field grouped>
      <b-field label="Empresa*" expanded>
        <SelectEmpresa
          :selected="form.empresaId"
          @empresaSelecionada="
            (empresaSelecionada) => (form.empresaId = empresaSelecionada.id)
          "
          :disabled="$route.params.id"
        />
      </b-field>
      <b-field :label="form.areaPrimaria ? 'Condutor:' : 'Condutor:*'" expanded>
        <b-input
          v-model="form.condutor"
          :disabled="form.areaPrimaria"
        ></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="is-flex is-flex-wrap-wrap">
      <b-field label="Placa:*" expanded>
        <b-input v-model="form.placa"></b-input>
      </b-field>

      <b-field label="Marca:*" expanded>
        <b-input v-model="form.marca"></b-input>
      </b-field>

      <b-field label="Modelo:*" expanded>
        <b-input v-model="form.modelo"></b-input>
      </b-field>

      <b-field label="Ano:*" expanded>
        <b-input v-model="form.ano"></b-input>
      </b-field>

      <b-field label="Cor:*" expanded>
        <b-input v-model="form.cor"></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="is-flex is-flex-wrap-wrap">
      <b-field label="Renavam:" expanded>
        <b-input v-model="form.renavam"></b-input>
      </b-field>
      <b-field label="Chassi:" expanded>
        <b-input v-model="form.chassi"></b-input>
      </b-field>
    </b-field>

    <!-- Data Início e Data Fim -->
    <b-field grouped v-if="form.tipo == 'AVULSO'">
      <b-field label="Data Início*" expanded>
        <b-datepicker
          v-model="form.dataInicio"
          placeholder="Selecione uma data"
        ></b-datepicker>
      </b-field>

      <b-field label="Data Fim*" expanded>
        <b-datepicker
          v-model="form.dataFim"
          placeholder="Selecione uma data"
        ></b-datepicker>
      </b-field>
    </b-field>

    <b-field>
      <!-- Justificativa -->
      <b-field label="Justificativa" v-if="form.tipo == 'AVULSO'">
        <b-input
          type="textarea"
          v-model="form.justificativa"
          maxlength="150"
          placeholder="Justificativa para visitante"
          :disabled="form.tipo !== 'AVULSO'"
        ></b-input>
      </b-field>
    </b-field>
    <div class="is-flex is-justify-content-center">
      <b-button type="is-primary" @click="formAction">{{
        this.$route.params.id ? "Atualizar" : "Enviar"
      }}</b-button>
    </div>
  </div>
</template>

<script>
import AcessosService from "@/services/AcessosService";
import Util from "@/services/Util";

import SelectEmpresa from "../Selects/SelectEmpresa.vue";
import CardComponent from "../Cards/CardComponent.vue";
import ApproveOrRefuseGroupButtons from "../ApproveOrRefuseGroupButtons.vue";
import StatusTag from "../StatusTag.vue";

export default {
  name: "FormAcessoVeiculo",
  components: {
    SelectEmpresa,
    CardComponent,
    ApproveOrRefuseGroupButtons,
    StatusTag,
  },
  data() {
    return {
      form: {
        classificacao: null,
        tipo: null,
        placa: null,
        marca: null,
        modelo: null,
        ano: null,
        cor: null,
        renavam: null,
        chassi: null,
        proprietario: null,
        justificativa: null,
        dataInicio: null,
        dataFim: null,
        empresaId: null,
        condutor: null,
        areaPrimaria: false,
        areaSecundaria: false,
      },
      ativo: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAcesso(this.$route.params.id);
    }
  },
  watch: {
    "form.areaPrimaria"(newValue) {
      if (newValue === true) {
        this.form.areaSecundaria = true;
      } else {
        this.form.areaSecundaria = false;
      }
    },
  },
  methods: {
    async aprovar() {
      try {
        if (this.form.areaPrimaria) {
          await AcessosService.setStatusAcessoVeiculo(
            this.$route.params.id,
            "APROVADO"
          );
          this.$buefy.toast.open({
            message: `Acesso Aprovado com sucesso!`,
            position: "is-bottom",
            type: "is-info",
          });
        } else {
          await AcessosService.setStatusAcessoVeiculo(
            this.$route.params.id,
            "ATIVO"
          );
          this.$buefy.toast.open({
            message: `Acesso Aprovado com sucesso!`,
            position: "is-bottom",
            type: "is-info",
          });
        }
        window.location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async recusar(payload) {
      try {
        const { id, motivoRecusa } = payload;
        await AcessosService.setRecusarAcessoVeiculo(id, motivoRecusa);
        this.$buefy.toast.open({
          message: `Acesso Recusado com sucesso!`,
          position: "is-bottom",
          type: "is-info",
        });
        window.location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    isRoleAreaSecundaria() {
      return Util.isRoleAreaSecundaria();
    },
    hasPermitionToApprove() {
      return Util.isAdmin();
    },
    hasPermitionToActivate() {
      return Util.isAdmin() || Util.isCadastro();
    },
    async switchActiveStatus() {
      try {
        const payload = {
          status: this.ativo ? "ATIVO" : "INATIVO",
        };
        console.log(payload);
        const res = this.ativo
          ? await AcessosService.setStatusAcessoVeiculo(
              this.$route.params.id,
              payload.status
            )
          : await AcessosService.setStatusAcessoVeiculoInativo(
              this.$route.params.id
            );
        this.$buefy.toast.open({
          message: `Status atualizado para ${this.ativo ? "ATIVO" : "INATIVO"}`,
          position: "is-bottom",
          type: "is-success",
        });
        window.location.reload();
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    empresaSelecionada(empresa) {
      this.form.empresaId = empresa;
    },
    pessoaSelecionada(pessoa) {
      this.form.pessoaId = pessoa;
    },
    async getAcesso(id) {
      try {
        const res = await AcessosService.getAcessoVeiculo(id);
        Object.assign(this.form, {
          ...res.data,
          empresaId: res.data.empresa.id,
          condutor: res.data.condutor,
          tipo: res.data.tipo,
          classificacao: res.data.veiculo.classificacao,
          placa: res.data.veiculo.placa,
          marca: res.data.veiculo.marca,
          modelo: res.data.veiculo.modelo,
          ano: res.data.veiculo.anoFabricacao,
          chassi: res.data.veiculo.chassi,
          renavam: res.data.veiculo.renavam,
          proprietario: res.data.veiculo.proprietario,
          cor: res.data.veiculo.cor,
          dataInicio: res.data.dataInicio
            ? new Date(res.data.dataInicio + "T12:00:00")
            : null,
          dataFim: res.data.dataFim
            ? new Date(res.data.dataFim + "T12:00:00")
            : null,
        });
        console.log(this.form.tipo);

        this.ativo = this.form.status == "ATIVO" ? true : false;
      } catch (error) {
        console.error("Erro ao buscar acesso:", error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    formAction() {
      if (this.$route.params.id) {
        this.updateAcessoVeiculo();
      } else {
        this.createAcessoVeiculo();
      }
    },
    async createAcessoVeiculo() {
      try {
        const res = await AcessosService.createAcessoVeiculo(this.form);
        this.$buefy.toast.open({
          message: "Acesso criado com sucesso",
          position: "is-bottom",
          type: "is-success",
        });
        this.$router.push("/acessos/veiculos");
        console.log(res);
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async updateAcessoVeiculo() {
      try {
        const res = await AcessosService.updateAcessoVeiculo(
          this.$route.params.id,
          this.form
        );
        this.$buefy.toast.open({
          message: "Atualização realizada com sucesso",
          position: "is-bottom",
          type: "is-success",
        });
        this.$router.push("/acessos/veiculos");
        console.log(res);
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response?.data?.message || error.message || "Erro ao atualizar o acesso.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },

    isAdmin() {
      return Util.isAdmin()
    }

  },
};
</script>

<style scoped>
.buttons.has-addons {
  display: flex;
  gap: 10px;
}
</style>
